<template>
  <div class="unbind_member">
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
      <a-form-item label="卡号(card_no)">
        <a-input @input="searchCardNo" @focus="selectAllText" @blur="hideSuggestList"
                 v-decorator="['cardNo', { rules: [{ required: true, message: '请输入卡号' }] }]"
        />

        <div id="suggest-list" v-if="matches.length > 0">
          <ul>
            <li v-for="match in matches" :key="match.phone" @mousedown="selectUser($event, match)" class="suggest-item">
              {{ match.cardNo }}
            </li>
          </ul>
        </div>

      </a-form-item>
      <a-form-item label="手机号">
        <a-input disabled="disabled" v-model="phone"
                 v-decorator="['mobile']"
        />
      </a-form-item>
      <a-form-item label="详细卡号">
        <a-input disabled="disabled" v-model="uid"
                 v-decorator="['uid']"
        />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">
          解绑
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import {unbindMember, searchCardNoApi} from "@/api/storeApi.js";

export default {
  name: "unbindMember",
  data() {
    return {
      phone: '',
      uid: '',
      matches: [],
      formLayout: 'horizontal',
      form: this.$form.createForm(this, {name: 'coordinated'}),
    };
  },
  methods: {
    // 当输入框聚焦时，自动全选内容
    selectAllText(event) {
      event.target.select();
    },
    searchCardNo: function (e) {
      const query = e.target.value;
      this.matches = [];
      this.form.setFieldsValue({
        mobile: null,
        uid: null,
      });
      if (query) {
        try {
          const _that = this;
          searchCardNoApi({"cardNo": query}).then((res) => {
            _that.matches = res.data;
          });

        } catch (error) {
          console.error("Error fetching card numbers:", error);
          this.matches = [];
        }
      } else {
        this.matches = [];
      }
    },
    selectUser: function (event, user) {
      event.preventDefault(); // 阻止默认事件
      event.stopPropagation(); // 阻止事件冒泡

      // 更新表单值和 mobile
      this.form.setFieldsValue({
        cardNo: user.cardNo,
        mobile: user.phone,
        uid: user.uid,
      });

      // 延迟关闭 suggest-list
      setTimeout(() => {
        this.matches = [];
      }, 100);
    },
    hideSuggestList() {
      // 延迟关闭 suggest-list，避免和点击事件冲突
      setTimeout(() => {
        this.matches = [];
      }, 200);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          unbindMember(values).then((res) => {
            if (res.success === false) {
              message.error(res.info);
            } else {
              message.success(res.info);
              setTimeout(function () {
                window.location.reload();
              }, 2000);
            }
          }).catch((err) => {
            console.log('解绑出错:');
            console.log(err);
            message.error("解绑出错");
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.unbind_member {
  box-sizing: border-box;
  width: 100%;
  background-color: #ffffff;
}

#suggest-list {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ddd;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li.suggest-item {
      padding: 8px 16px;
      cursor: pointer;

      &:hover {
        background-color: #f0f0f0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/unbindMember/unbindMember.vue